import React from 'react';
import { Box } from '@mui/material';
import { themeColors } from '../../../theme';
import { PremiumIcon } from './PremiumIcon';
import { BoxProps } from '@mui/system';
import { LicenseHeight } from '../../Collections/CollectionsPanel/Media/License';
import { withStyles } from 'tss-react/mui';

export const PremiumBadge = withStyles(
  (props: BoxProps & { height?: number }) => (
    <Box {...props}>
      <PremiumIcon />
    </Box>
  ),
  (theme, { height = LicenseHeight }) => ({
    root: {
      display: 'flex',
      width: 'fit-content',
      height,
      padding: Math.round(height * 0.25),
      color: 'white',
      borderRadius: theme.shape.borderRadius,
      background: themeColors.orangeGradient,
      ['& > svg']: {
        // this badge sizes from its height, so it opts out of the width CustomIcon sets by default
        height: '100%',
        width: 'auto',
        ['& > g > path']: {
          fill: 'white'
        }
      }
    }
  })
);
